export default __webpack_public_path__ + "static/media/i_michael.ab838476.svg";